import { Injectable } from '@angular/core';

import { ModalDialogOptions, ModalDialogService } from '@frontend/sports/modal/feature';
import { HtmlNode } from '@frontend/vanilla/core';

import { SwitcherToggleService } from '../../../../event-details/event-switcher/services/switcher-toggle.service';
import { MeetingSwitcherComponent } from '../meeting-switcher/meeting-switcher.component';

@Injectable({ providedIn: 'root' })
export class MeetingSwitcherToggleService extends SwitcherToggleService {
    private readonly dialogCssClass = 'event-switcher-dialog meeting-switcher-toggle-dialog';
    constructor(dialogService: ModalDialogService, htmlNode: HtmlNode) {
        super(dialogService, htmlNode, true);
    }

    openSwitcher(): void {
        const options: ModalDialogOptions<void> = {
            settings: {
                cssClass: this.dialogCssClass,
                backdropClass: this.dialogCssClass,
                scrollTargetQuerySelector: 'ms-event-switcher',
                fit: false,
            },
        };
        this.open(MeetingSwitcherComponent, options);
    }
}
